import React from 'react';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import Heading from '../../../../../common/Heading';
import { TextInput } from '../../../../../common/FormFields';
import formStyles from '../../../../../styles/forms.module.scss';
import commonStyles from '../../../FacilityData/StepWindFacilityData.module.scss';

function StepCoopChargingData() {
  return (
    <section className={commonStyles.stepCoopChargingData}>
      <Heading level={2} className={commonStyles.heading}>
        <FormattedMessage id="offerWizard.stepCoopChargingData.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPairSingle}>
          <Field
            name="coopChargingData.numberOfHotelLocations"
            component={TextInput}
            labelMsg="offerWizard.coopChargingData.numberOfHotelLocations.label"
            required
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name="coopChargingData.numberOfRooms"
            component={TextInput}
            labelMsg="offerWizard.coopChargingData.numberOfRooms.label"
            required
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name="coopChargingData.numberOfParkingSpaces"
            component={TextInput}
            labelMsg="offerWizard.coopChargingData.numberOfParkingSpaces.label"
          />
        </div>
      </div>
    </section>
  );
}

export default StepCoopChargingData;
